module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "pg29lev1"
    }
  }), _c('img', {
    attrs: {
      "alt": "Razor clams with tzatziki and pomegranate",
      "src": "images/f0029-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "recipe_hdnote"
  }, [_vm._v("Whenever there are starters being served in Turkey, a small dish of tzatziki is likely to appear. It’s a simple blend of cucumber, garlic, and creamy yogurt, but each family and restaurant will have their own secret method and ratio, making it their signature.")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_hdnote"
  }, [_vm._v("In my view, the perfect tzatziki is made using a crunchy Lebanese or ridge cucumber with the seeds scooped out; salting it in a colander also draws out the moisture. Pomegranate seeds are the perfect way to elevate any dish, savory or sweet, and they add an exceedingly satisfying crunch.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "image",
      "src": "images/f0028-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Serves 4 as a canap"), _c('span', {
    staticClass: "display_type"
  }, [_vm._v("é")]), _vm._v(" or starter")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Preparation time: 10 minutes")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Cooking time: 30 seconds")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("8 razor clams")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v(" lemon")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("5 tbsp Greek yogurt")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("1 small clove of garlic, peeled and minced")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("pinch of sea salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v(" Lebanese cucumber or ridge cucumber, peeled")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("4")]), _vm._v(" cup pomegranate seeds")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Bring a large saucepan of water to a boil. Set up a large bowl of iced water nearby. Drop 4 razor clams into the boiling water, then fish them out almost immediately with a pair of tongs and drop them straight into the iced water. They should open but not cook. Repeat with the remaining clams.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Pull the clams out of their shells and use a pair of scissors to cut the black sac out of the clam, remove the “beak,” then chop the clams into thumbnail-size pieces. Put the clams into a bowl and squeeze a little lemon juice over the top. Wash and dry 8 half-shells and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Mix together the yogurt, garlic, salt, and a squeeze of lemon. Place in a disposable piping bag or ziplock bag and snip off the end.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Cut the cucumber in half lengthwise and scoop out the seeds. Cut into fine julienne strips on a mandoline or by hand.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Put 3 or 4 dollops of the garlic yogurt along a half-shell. Put the clam pieces in between the yogurt. Garnish with cucumber and scatter some of the pomegranate seeds over the top. Repeat with the remaining half-shells and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar2_hd"
  }, [_vm._v("Tip")]), _vm._v(" "), _c('p', {
    staticClass: "sidebar1_txt"
  }, [_c('em', [_vm._v("A good way to tell if your clams are fresh is to tickle the foot, which should retract right away; if there is no sign of life, don’t buy them")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0029-02.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33139b49","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/14-chapter08.vue
// module id = 96
// module chunks = 0